import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { ViewedProps } from './model';

export const Viewed: React.FC<ViewedProps> = () => {
  return (
    <Typography component="div" sx={{ color: 'gray' }} variant="small text">
      Просмотрено
    </Typography>
  );
};
